import React from 'react'
import PropTypes from 'prop-types';
import FishboneCard from './FishboneCard';

function GapDataserieBoxContent(props) {
   
    const {
        inputParam_GapId = null,
        inputParam_GapAnalyzeId = null,
        inputParam_ElementId = null,
        inputParam_GapRevision = null,
        inputParam_DataserieFullData = null,
        inputParam_GapRevisionDataserieList = null,
        inputParam_GapElementList = null,
        inputParam_SelectecDataserieId = null,
        inputParam_SetFireGetLastActions = null,
    } = props;

    return (
        <>
            {
                inputParam_DataserieFullData.revisionDataserieFullList.filter(x => inputParam_SelectecDataserieId !== 0 ? x.id === inputParam_SelectecDataserieId : true).map((item, index) => (
                    <div className='kaka' key={index}>
                        <FishboneCard
                            inputParam_Index={index}
                            inputParam_Item={item}
                            inputParam_GapId={inputParam_GapId}
                            inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                            inputParam_ElementId={inputParam_ElementId}
                            inputParam_GapRevision={inputParam_GapRevision}
                            inputParam_DataserieFullData={inputParam_DataserieFullData}
                            inputParam_GapRevisionDataserieList={inputParam_GapRevisionDataserieList}
                            inputParam_GapElementList={inputParam_GapElementList}
                            inputParam_SetFireGetLastActions={inputParam_SetFireGetLastActions}
                        />
                    </div>    
                ))
            }
        </>
    );
}

GapDataserieBoxContent.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevision: PropTypes.object,
    inputParam_DataserieFullData: PropTypes.object.isRequired,
    inputParam_GapRevisionDataserieList: PropTypes.array.isRequired,
    inputParam_GapElementList: PropTypes.array.isRequired,
};

export default GapDataserieBoxContent;